import { Directive, Input, Output, EventEmitter, HostListener, ElementRef, OnInit, ViewContainerRef, AfterViewInit } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { PermissionMetadata } from 'src/app/modules/controls/enums/permissions';


@Directive({ selector: "[permission]" })
export class PermissionDirective implements AfterViewInit {
	@Input() permission: number;

	constructor(private el: ElementRef, private viewContainer: ViewContainerRef, private authService: AuthService) {
	}
  ngAfterViewInit(): void {

    const user = this.authService.user;
    const userType = Number(user?.userType);
    const userPermissions = this.authService.user.permissions;


    const hasPermission = (userPermissions & this.permission) > 0;
    const allowUserType4 = PermissionMetadata[this.permission]?.allowUserType4 ?? false;


    if (!hasPermission && !(allowUserType4 && userType === 4)) {
      this.el.nativeElement.remove();
    }
  }
}
